import { render, staticRenderFns } from "./sky-tel.vue?vue&type=template&id=2c5cff3b&scoped=true"
import script from "./sky-tel.vue?vue&type=script&lang=js"
export * from "./sky-tel.vue?vue&type=script&lang=js"
import style0 from "./sky-tel.vue?vue&type=style&index=0&id=2c5cff3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5cff3b",
  null
  
)

export default component.exports